import { IRejectSuggestedFaqDTO } from '@/models/suggestedFaq.model';
import { SUGGESTED_FAQ_REJECT_REASON } from '../helpers';

class RejectSuggestedFaqDTO implements IRejectSuggestedFaqDTO {
  reviewId: string;

  reason: string;

  constructor({ reviewId, reason }: { reviewId: string; reason?: string }) {
    this.reviewId = reviewId;
    this.reason = reason || SUGGESTED_FAQ_REJECT_REASON;
  }
}

export default RejectSuggestedFaqDTO;
